<template>
    <div>

    </div>  
</template>

<script>
import vue from 'vue';
export default new vue;
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
<style scoped>

</style>

